import React, { useState } from 'react';
import { UploadFile as UploadFileIcon } from '@mui/icons-material';
import UploadedFilesInline from './UploadedFilesInline';
import { Card, CardContent, Typography } from '@mui/material';

export default function DragDropArea({
  key,
  label,
  required = false,
  files = [],
  onFilesAdded,
  onFileDelete,
  onFileRename,
  cardSx = {},
}) {
  const [dragging, setDragging] = useState(false);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    if (selectedFiles.length > 0) {
      onFilesAdded(Array.from(selectedFiles));
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      onFilesAdded(Array.from(droppedFiles));
    }
  };

  return (
    <Card
      variant="outlined"
      sx={[
        {
          borderWidth: 2,
          borderStyle: 'dashed',
          borderRadius: 2,
          borderColor: dragging ? 'primary.main' : '#cbd5e1',
          backgroundColor: dragging ? '#f0f9ff' : 'transparent',
          mt: 2,
        },
        cardSx,
      ]}
    >
      <CardContent sx={{ py: 4 }}>
        <Typography variant="subtitle2" gutterBottom>
          {label} {required && <span style={{ color: '#f87171' }}>*</span>}
        </Typography>

        <label
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={() => setDragging(true)}
          onDragLeave={() => setDragging(false)}
          onDrop={handleDrop}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            gap: 8,
          }}
        >
          <UploadFileIcon sx={{ fontSize: 40 }} />
          <Typography variant="body2" color="text.secondary">
            Drag and drop a file here or click
          </Typography>

          <input
            id={`file-upload-${key}`}
            type="file"
            hidden
            multiple
            onChange={handleFileChange}
          />
        </label>

        <UploadedFilesInline
          files={files}
          onDelete={onFileDelete}
          onRename={onFileRename}
          showProgress
        />
      </CardContent>
    </Card>
  );
}
